import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import InsertLinkRoundedIcon from '@mui/icons-material/InsertLinkRounded';
import Loader from '../components/loader';
import FadeItem from '../components/fadeItem';
import usePageBackground from '../hooks/usePageBackground';
import * as endPoints from '../assets/js/endpoints';

export default function Formaciones() {
  const [loading, setLoading] = useState(true);
  const [formations, setFormations] = useState([]);
  usePageBackground('howHelp-background-color');

  useEffect(() => {
    endPoints
      .getAllFormations()
      .then((data) => {
        const list = Array.isArray(data) ? data : data?.data || [];
        setFormations(list);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loader />;

  return (
    <>
      <Helmet>
        <title>Formaciones | CES</title>
        <meta name="description" content="Formaciones disponibles en CES." />
      </Helmet>
      <Box sx={{ minHeight: '100vh', py: { xs: 4, md: 8 }, backgroundColor: '#FFFCE8' }}>
        <Container maxWidth="lg">
          <FadeItem
            text="Formaciones"
            variant="h2"
            style={{ fontFamily: 'Great Vibes, cursive', fontWeight: 400, color: '#66ab5ea3', mb: 3, textAlign: 'center' }}
          />
          {formations.length === 0 ? (
            <Typography sx={{ textAlign: 'center', color: '#7a7442' }}>
              Ahora mismo no hay formaciones publicadas.
            </Typography>
          ) : (
            <Box sx={{ display: 'grid', gap: 3 }}>
              {formations.map((formation) => (
                <Paper key={formation.id} elevation={2} sx={{ p: { xs: 2, md: 3 }, borderRadius: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Typography variant="h5" sx={{ color: '#66ab5ea3', mb: 1, fontWeight: 700, fontFamily: 'Nunito, sans-serif', }}>
                    {formation.title}
                  </Typography>
                  {formation.description && (
                    <Typography sx={{ color: '#7a7442', whiteSpace: 'pre-line', mb: 2 }}>
                      {formation.description}
                    </Typography>
                  )}
                  {formation.link?.trim() && (
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<InsertLinkRoundedIcon />}
                      component="a"
                      href={formation.link.trim()}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{cursor: 'pointer', textTransform: 'none', fontWeight: 500, backgroundColor: '#A89EA8', 
                        padding: '0.6em 2rem', fontFamily: 'Nunito, sans-serif',
                        '&:hover': { backgroundColor: '#6B6B6B', color: '#fff', cursor: 'pointer', } }}
                    >
                      Ir a la formación
                    </Button>
                  )}
                </Paper>
              ))}
            </Box>
          )}
        </Container>
      </Box>
    </>
  );
}
